import { NuevaReservaForm } from './NuevaReservaForm.js';

/**
 * Envoltorio modal del alta manual de reservas ("Nueva reserva"). Función de
 * render pura: devuelve un string HTML, sin estado ni efectos. Reutiliza el
 * overlay de `ConfirmDialog` (backdrop `fixed inset-0` + card centrada,
 * `role="dialog"` + `aria-modal`) y aloja el formulario `NuevaReservaForm`
 * como cuerpo — la lógica de alta (submit `data-action="reserva-crear"` →
 * `handleReservaCreate`) no cambia, esto es solo presentación.
 *
 * El wiring (`js/admin.js`) cablea tras cada render del mount:
 * - ✕ (`data-action="reserva-nueva-cerrar"`) y click en el backdrop
 *   (`data-action="reserva-nueva-backdrop"`, solo cuando el target ES el
 *   backdrop) → cierran el modal.
 * - el submit del formulario embebido → `handleReservaCreate`.
 *
 * Card más ancha que el `ConfirmDialog` (`max-w-2xl`) porque el formulario es
 * una grilla de hasta 4 columnas; scroll vertical propio para viewports bajos.
 */

/**
 * Modal del formulario de reserva. Sirve tanto al alta como a la edición: el
 * mismo formulario, el mismo plano de mesas, la misma cascada de fecha. Un
 * segundo modal para editar sería el mismo layout con otro título y otro sitio
 * donde arreglar cada bug de este.
 *
 * @param {{ mode?: 'crear' | 'editar', mesasHtml?: string }} [options]
 * @returns {string} HTML del modal.
 */
export const NuevaReservaModal = ({ mode = 'crear', mesasHtml = '' } = {}) => `
    <div role="dialog" aria-modal="true" aria-label="${mode === 'editar' ? 'Editar reserva' : 'Nueva reserva'}"
        data-action="reserva-nueva-backdrop"
        class="fixed inset-0 z-[200] flex items-start justify-center bg-black/50 px-6 py-10 overflow-y-auto">
        <div class="relative bg-base rounded-[2rem] p-8 max-w-3xl w-full shadow-2xl">
            <button type="button" data-action="reserva-nueva-cerrar" aria-label="Cerrar"
                class="absolute top-6 right-6 flex h-9 w-9 items-center justify-center rounded-full border border-border-subtle text-text-muted hover:text-text-primary focus:outline-none focus:border-brand">
                <i class="fa-solid fa-xmark" aria-hidden="true"></i>
            </button>
            ${NuevaReservaForm({ mode, mesasHtml })}
        </div>
    </div>
`;
